import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import { addRecomendedMovie} from '../utils/MovieSlice'
import {API_OPTIONS} from '../utils/Constants'


const useRecomendedMovies = (MovieId) =>{
  const dispatch = useDispatch();
 
  const  getRecomendedMovies = async () =>{
  
  const data = await fetch('https://api.themoviedb.org/3/movie/'+ MovieId +'/recommendations?language=en-US&page=1', API_OPTIONS)
  const json = await data.json();
  dispatch( addRecomendedMovie(json.results)); 
}

useEffect(()=>{
    getRecomendedMovies();
},[])}

export default useRecomendedMovies;